/**
 * @prop --max-height: Maximum height of table
 * @prop --min-width: Minium width of table
 * @prop --cell-padding: Cells padding
 * @prop --search-input-width: Search input width from small breakpoint

 * @prop --stzh-table-max-width: **Global**: Maximum height of table
 * @prop --stzh-table-min-width: **Global**: Minium width of table
 * @prop --stzh-table-cell-padding: **Global**: Cells padding
 * @prop --stzh-table-search-input-width: **Global**: Search input width from small breakpoint
 */

stzh-datatable {
  @include host;
  @include table-host();
}

.stzh-datatable {
  @include table("datatable");

  &__caption {
    @include visuallyhidden;
  }
}
